export const CommonPdf = (data, name) => {
    const blob = new Blob([data])
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name + '.pdf');
    document.body.appendChild(link);
    link.click();
}

export const CommonPdfOpen = (data, name) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    // Open a new tab or window with the PDF content
    window.open(url, '_blank');
};


export const CommonExcelOpen = (data, name) => {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    // Open a new tab or window with the PDF content
    window.open(url, '_blank');
};

export const ImageOpen = (data, name) => {
    const blob = new Blob([data], { type: 'Image/jpeg' });
    const url = window.URL.createObjectURL(blob);
    // Open a new tab or window with the PDF content
    window.open(url, '_blank');
};

export const FileViewOpen = async (event,url) => {
        event.preventDefault();
        try {
          // Fetch the file from the server
          const response = await fetch(url);
          // Get the content type from the headers
          const contentType = "image/jpeg";// response.headers.get('Content-Type');
          // Get the file as a Blob
          const fileBlob = await response.blob();
          // Create a URL for the Blob
          const fileURL = window.URL.createObjectURL(fileBlob);
          // Open the file in a new tab
          window.open(fileURL, '_blank');
        } catch (error) {
        }
    
     
};